'use client';

import { useEffect, useState } from 'react';

import type { ClientUser } from '~/service/user';

import { Gtm } from './providers/gtm';

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<ClientUser>();

  useEffect(() => {
    fetch('/api/user')
      .then(res => res.json())
      .then(json => setUser(json));
  }, []);

  useEffect(() => {
    if (!user) {
      return;
    }
    // This is used by OptInMonster to target external users. Confirm with @emf before removing.
    // deprecated. use `internal === true`
    // sessionStorage.setItem('traffic', user.type);
    sessionStorage.setItem('internal', (user.type === 'internal').toString());
  }, [user]);

  useEffect(() => {
    // Sep 5, 2024 - The old trafficType localstorage item is replaced by our user cookie. I'd
    //  prefer to not just leave it there, so we just remove it wherever it is set.
    localStorage.removeItem('mf_tr');
  }, []);

  return (
    // track event can be imported directly but is included in context for backwards compat
    <>
      <Gtm user={user} />
      {children}
    </>
  );
}
